module.exports = __webpack_public_path__ + "images/device_premium.e1893a21cd91af78280f16f24e36a38c.png";